import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';
import { compose } from 'react-apollo';

import s from './FeaturedPayPalCancel.css';
import Link from '../../../../components/Link/Link';

class FeaturedPayPalCancel extends Component {
  static propTypes = {
    listId: PropTypes.number
  };

  render() {
    const { listId } = this.props;

    return (
      <div className={s.container}>
        <div className={s.card}>
          <div className={s.cancelIcon}>✕</div>
          <h2 className={s.title}>Pago Cancelado</h2>
          <p className={s.subtitle}>
            Has cancelado el proceso de pago con PayPal. 
            Tu bote no ha sido destacado.
          </p>
          <p className={s.info}>
            No se ha realizado ningún cargo a tu cuenta.
          </p>
          <div className={s.actions}>
            <Link to="/user/boats" className={s.primaryButton}>
              Volver a Mis Botes
            </Link>
            <Link to="/" className={s.secondaryButton}>
              Ir al Inicio
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s)
)(FeaturedPayPalCancel);
